const ENABLED_VALUE = 'true';

export enum FeatureToggle {
    GA_EVENT_LOGGING = 'enable_ga_event_logging',
    MAN_SCL_BRAKE_WEAR = 'enable_man_scl_brake_wear',
}

export const isFeatureEnabled = (featureKey: FeatureToggle) => {
    return window.localStorage.getItem(featureKey) === ENABLED_VALUE;
};

export const isGaEventLoggingFeatureToggleEnabled = () => isFeatureEnabled(FeatureToggle.GA_EVENT_LOGGING);
export const isManSCLBrakeWearFeatureToggleEnabled = () => isFeatureEnabled(FeatureToggle.MAN_SCL_BRAKE_WEAR);
